/**
 * api.js — Central API URL resolver
 *
 * Always uses the production API (https://api.qeduvo.com).
 * For local dev against a local backend, temporarily change FORCE_LOCAL to true.
 */

const FORCE_LOCAL = false;
const BACKEND_PORT = 9082;
const PC_LAN_IP = '192.168.1.100';

export const API_URL = FORCE_LOCAL
  ? `http://${PC_LAN_IP}:${BACKEND_PORT}`
  : 'https://api.qeduvo.com';

export const API = API_URL; // alias for files using `API`

export const WS_URL = FORCE_LOCAL
  ? `ws://${PC_LAN_IP}:9083`
  : 'wss://api.qeduvo.com/community';

export default API_URL;
